/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PropertyOperatorMapping } from './PropertyOperatorMapping';
import {
    PropertyOperatorMappingFromJSON,
    PropertyOperatorMappingFromJSONTyped,
    PropertyOperatorMappingToJSON,
} from './PropertyOperatorMapping';
import type { TableFilter } from './TableFilter';
import {
    TableFilterFromJSON,
    TableFilterFromJSONTyped,
    TableFilterToJSON,
} from './TableFilter';
import type { TableFilterCommands } from './TableFilterCommands';
import {
    TableFilterCommandsFromJSON,
    TableFilterCommandsFromJSONTyped,
    TableFilterCommandsToJSON,
} from './TableFilterCommands';

/**
 * 
 * @export
 * @interface TableFilterSettings
 */
export interface TableFilterSettings {
    /**
     * 
     * @type {string}
     * @memberof TableFilterSettings
     */
    activeGlobalFiltersLabel?: string;
    /**
     * 
     * @type {TableFilter}
     * @memberof TableFilterSettings
     */
    activeTableFilter?: TableFilter;
    /**
     * 
     * @type {Array<TableFilter>}
     * @memberof TableFilterSettings
     */
    availableTableFilters: Array<TableFilter>;
    /**
     * 
     * @type {TableFilterCommands}
     * @memberof TableFilterSettings
     */
    commands?: TableFilterCommands;
    /**
     * 
     * @type {Array<PropertyOperatorMapping>}
     * @memberof TableFilterSettings
     */
    propertyOperatorMappings: Array<PropertyOperatorMapping>;
    /**
     * 
     * @type {boolean}
     * @memberof TableFilterSettings
     */
    globalFilterActive: boolean;
}

/**
 * Check if a given object implements the TableFilterSettings interface.
 */
export function instanceOfTableFilterSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "availableTableFilters" in value;
    isInstance = isInstance && "propertyOperatorMappings" in value;
    isInstance = isInstance && "globalFilterActive" in value;

    return isInstance;
}

export function TableFilterSettingsFromJSON(json: any): TableFilterSettings {
    return TableFilterSettingsFromJSONTyped(json, false);
}

export function TableFilterSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableFilterSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeGlobalFiltersLabel': !exists(json, 'activeGlobalFiltersLabel') ? undefined : json['activeGlobalFiltersLabel'],
        'activeTableFilter': !exists(json, 'activeTableFilter') ? undefined : TableFilterFromJSON(json['activeTableFilter']),
        'availableTableFilters': ((json['availableTableFilters'] as Array<any>).map(TableFilterFromJSON)),
        'commands': !exists(json, 'commands') ? undefined : TableFilterCommandsFromJSON(json['commands']),
        'propertyOperatorMappings': ((json['propertyOperatorMappings'] as Array<any>).map(PropertyOperatorMappingFromJSON)),
        'globalFilterActive': json['globalFilterActive'],
    };
}

export function TableFilterSettingsToJSON(value?: TableFilterSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activeGlobalFiltersLabel': value.activeGlobalFiltersLabel,
        'activeTableFilter': TableFilterToJSON(value.activeTableFilter),
        'availableTableFilters': ((value.availableTableFilters as Array<any>).map(TableFilterToJSON)),
        'commands': TableFilterCommandsToJSON(value.commands),
        'propertyOperatorMappings': ((value.propertyOperatorMappings as Array<any>).map(PropertyOperatorMappingToJSON)),
        'globalFilterActive': value.globalFilterActive,
    };
}

